import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  fetchCourseVersionData,
  fetchCourseSections
} from "../../redux/actions/contentCoursesActions";
import PolicyBuilderContent from "./PolicyBuilderContent";
import AcknowledgementModal from "./AcknowledgementModal";

const PolicyBuilder = ({
  policyId,
  versionId,
  disabled,
  canManageContentForPolicy
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [changeActivity, setChangeActivity] = useState(null);

  const getContent = () => {
    dispatch(fetchCourseSections(versionId));
  };

  useEffect(() => {
    getContent();
    dispatch(fetchCourseVersionData(policyId, versionId));
  }, []);

  const handleEditActivityClick = (activityType, activityId, sectionId) => {
    setChangeActivity({
      type: activityType,
      activityId: activityId,
      sectionId: sectionId
    });
  };

  const handleAddActivityToSectionClick = (activityType, sectionId) => {
    setChangeActivity({ type: activityType, sectionId: sectionId });
  };

  const handleActivityModalClose = needsReload => {
    setChangeActivity(null);
    if (needsReload) {
      getContent();
    }
  };

  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" mb={3}>
        <Typography variant="h5">
          {t("courseVersion.details.policyOutline")}
        </Typography>
      </Box>
      <PolicyBuilderContent
        versionId={versionId}
        disabled={disabled || !canManageContentForPolicy}
        onAddActivityClick={handleAddActivityToSectionClick}
        onEditActivityClick={handleEditActivityClick}
        canManageContentForPolicy={canManageContentForPolicy}
      />
      {changeActivity?.type === "acknowledgement" && (
        <AcknowledgementModal
          onClose={handleActivityModalClose}
          open={changeActivity.type === "acknowledgement"}
          shortCourseId={changeActivity.sectionId}
          acknowledgementId={changeActivity.activityId}
        />
      )}
    </Box>
  );
};

export default PolicyBuilder;

PolicyBuilder.propTypes = {
  policyId: PropTypes.string,
  versionId: PropTypes.string,
  disabled: PropTypes.bool
};
